import axios from 'axios';

export default axios.create({
  baseURL: `https://main.gmaisp.tech/api/`, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
});
